import React from "react";

/**
 * A small key marker shown next to a data table's primary-key column header,
 * so it's visible which column is the relation's key (see the relation catalog
 * in powerFlow/language/schema.ts — every entity table is keyed by `id`).
 */
const KeyIcon: React.FC<{ title?: string }> = ({ title = "Primary key" }) => (
  <span
    title={title}
    aria-label="key"
    style={{ marginLeft: 4, fontSize: "0.85em", opacity: 0.55, cursor: "help", userSelect: "none" }}
  >
    🔑
  </span>
);

export default KeyIcon;
